const state = {
  newProjectModal: false,
  modalData: [],
  newThreadModal: false,
  previewFileModal: false,
  fileModalData: []
}

export default {
  namespaced: true,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js